import { MenuOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { arrayMoveImmutable } from 'array-move';
import React, { useEffect, useState, useRef } from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
const DragHandle = SortableHandle(() => (
  <MenuOutlined
    style={{
      cursor: 'grab',
      color: '#999',
    }}
  />
));
const SortableItem = SortableElement((props) => <tr {...props} />);
const SortableBody = SortableContainer((props) => <tbody {...props} />);
const TableTest = ({data, columns, onChange= () => {}}) => {

  const [dataSource, setDataSource] = useState([]);
  const containerPosition = useRef({})

  useEffect(() => {
    containerPosition.current = {}
    setDataSource(data.map((e,i) => {
      containerPosition.current = {...containerPosition.current,[(e || {}).id]:i}
      return {...e,index:i}
    }))
  },[data])

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const newData = arrayMoveImmutable(dataSource.slice(), oldIndex, newIndex).filter(
        (el) => !!el,
      );
      onChange(newData.map(e => e.id))
      setDataSource(newData);
    }
  };

  const DraggableContainer = (props) => (
    <SortableBody
      useDragHandle
      disableAutoscroll
      helperClass="row-dragging"
      onSortEnd={onSortEnd}
      {...props}
    />
  );

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    // function findIndex base on Table rowKey props and should always be a right array index
    const index = dataSource.findIndex((x) => x.index === restProps['data-row-key']);
    return <SortableItem index={index} {...restProps} />;
  };

  return (
    <Table
      pagination={false}
      dataSource={dataSource}
      columns={[{
        title: 'Sort',
        dataIndex: 'sort',
        width: 120,
        className: 'drag-visible',
        render: (__,_,index) => {
          return (
            <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
              <p style={{margin:'0px',padding:'0px',marginRight:'20px'}}>#{index+1}</p>
              <DragHandle />
            </div>
          )
        },
      },...columns]}
      rowKey="index"
      components={{
        body: {
          wrapper: DraggableContainer,
          row: DraggableBodyRow,
        },
      }}
    />
  );
};
export { TableTest };